import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {PaymentMethod} from '@gatewee/types/payment';

@Component({
  selector: 'gatewee-checkout-payment-methods',
  templateUrl: './gatewee-checkout-payment-methods.component.html',
  styleUrls: ['./gatewee-checkout-payment-methods.component.css'],
  standalone: false,
})
export class GateweeCheckoutPaymentMethodsComponent {
  @Input({required: true}) paymentMethodGroup!: FormGroup;
  @Input() methods: PaymentMethod[] = [];
  /** When set, used as i18n key for the card title (default: full “accepted methods” title). */
  @Input() titleKey?: string;
  /** When set, overrides the default hint i18n key. */
  @Input() hintKey?: string;

  readonly defaultTitleKey = 'features.checkouts.wizard.paymentMethods.title';
  readonly defaultHintKey = 'features.checkouts.wizard.paymentMethods.hint';

  @Output() selectAll = new EventEmitter<void>();
  @Output() clearSelection = new EventEmitter<void>();
}
